<script setup lang="ts">
import { TermsOfUsePage } from '@features/flatpages'
</script>

<template>
  <terms-of-use-page />
</template>
